import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet-async'
import { Box } from '@machobear/design-system'
import PageTitleBar from '@/components/page-title'
import FormStepper from './components/form-stepper'
import { Listing, FormStep } from './types'
import { formatListingAddress } from './util'

interface LayoutProps {
  data: Listing
  step?: FormStep
  metaTitle?: string
  sidebarComponent?: React.ReactNode
  children: React.ReactNode
}

const Layout = ({ data, step, metaTitle, sidebarComponent, children }: LayoutProps) => {
  const { t } = useTranslation()

  const pageTitle = data?.building?.full_street_name
    ? formatListingAddress(data)
    : t('Create a new listing', 'Create a new listing')

  return (
    <>
      <Helmet>
        <title>{metaTitle || t('Create Listing', 'Create Listing')}</title>
      </Helmet>
      <PageTitleBar customChild={null}>{pageTitle}</PageTitleBar>
      <Box
        paddingTop={{ mobile: 'gutter', tablet: 'gutter', desktop: 'xxxlarge' }}
        paddingBottom={{ mobile: 'gutter', tablet: 'xxxlarge' }}
        paddingX={{ mobile: 'none', tablet: 'xlarge', desktop: 'xxxlarge' }}
        background="neutralLight"
        height="full"
        display="flex"
        justifyContent="center"
        alignItems="flexStart"
        flexDirection="row"
      >
        <Box style={{ maxWidth: '916px', width: '100%' }}>
          <Box
            display="flex"
            flexDirection={{ mobile: 'column', tablet: 'column', desktop: 'row' }}
            gap={{ mobile: 'none', tablet: 'none', desktop: 'gutter' }}
            position="relative"
          >
            <Box
              flexShrink={0}
              position={{ desktop: 'sticky' }}
              style={{ top: '128px', height: 'fit-content' }}
            >
              {sidebarComponent || (step && <FormStepper step={step} data={data} />)}
            </Box>
            <Box
              width="full"
              marginBottom={{ mobile: 'none', tablet: 'none', desktop: 'xxxlarge' }}
              style={{ minWidth: 0 }}
            >
              {children}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default Layout
